import { Box, Text } from "@mantine/core";
import { patientRowStyle } from "./DocumentHeaderStyles";

interface InlineFieldPairProps {
  label: string;
  children: React.ReactNode;
}

export function InlineFieldPair({ label, children }: InlineFieldPairProps) {
  return (
    <Box style={{ display: "flex", gap: 6, alignItems: "baseline" }}>
      <Text style={{ ...patientRowStyle, textTransform: "uppercase" }}>
        {label}:
      </Text>
      {children}
    </Box>
  );
}
